import { render, staticRenderFns } from "./AgeGateSection.vue?vue&type=template&id=e07e6abe&scoped=true&"
import script from "./AgeGateSection.vue?vue&type=script&lang=js&"
export * from "./AgeGateSection.vue?vue&type=script&lang=js&"
import style0 from "./AgeGateSection.vue?vue&type=style&index=0&id=e07e6abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e6abe",
  null
  
)

export default component.exports